/* Work'N Gear - Theme JS */

document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.getElementById('wng-cart-notification');
  var cartDrawerItems = document.getElementById('wng-cart-notification-items');
  var cartDrawerCount = document.getElementById('wng-cart-notification-count');
  var cartDrawerSubtotal = document.getElementById('wng-cart-notification-subtotal');
  var cartDrawerShippingText = document.getElementById('wng-cart-notification-shipping-text');
  var cartDrawerProgress = document.getElementById('wng-cart-notification-progress');
  var cartDrawerRecommendations = document.getElementById('wng-cart-notification-recommendations');
  var cartDrawerRecommendationGrid = document.getElementById('wng-cart-notification-recommendation-grid');
  var freeShippingThreshold = cartDrawer ? parseInt(cartDrawer.dataset.freeShippingThreshold, 10) : 7500;

  function formatMoney(cents) {
    return ((cents || 0) / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Unable to update cart.');
        }
        return data;
      });
    });
  }

  function fetchCart() {
    return fetchJson('/cart.js');
  }

  function setCartDrawerBusy(isBusy) {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-loading', isBusy);
    cartDrawer.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    cartDrawer.querySelectorAll('button').forEach(function(button) {
      if (button.hasAttribute('data-wng-cart-notification-close')) return;
      button.disabled = isBusy;
    });
  }

  function getCartItemCountText(count) {
    return count + ' item' + (count === 1 ? '' : 's');
  }

  function getVariantText(item) {
    if (!item) return '';

    if (item.options_with_values && item.options_with_values.length) {
      return item.options_with_values
        .filter(function(option) {
          return option && option.value && option.value !== 'Default Title';
        })
        .map(function(option) {
          return option.name + ': ' + option.value;
        })
        .join(' / ');
    }

    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }

    return '';
  }

  function getImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  }

  function renderCartItems(cart) {
    if (!cartDrawerItems) return;

    if (!cart || !cart.items || !cart.items.length) {
      cartDrawerItems.innerHTML = '<div class="wng-cart-notification__empty"><p>Your cart is empty.</p><a href="/collections/all">Browse products</a></div>';
      return;
    }

    cartDrawerItems.innerHTML = cart.items.map(function(item) {
      var imageUrl = getImageUrl(item.image || item.featured_image);
      var variantText = getVariantText(item);
      var itemTitle = item.product_title || item.title || 'Cart item';
      var itemUrl = item.url || '/cart';
      var nextQuantity = item.quantity + 1;
      var previousQuantity = Math.max(item.quantity - 1, 1);
      var minusDisabled = item.quantity <= 1 ? ' disabled aria-disabled="true"' : '';

      return [
        '<article class="wng-cart-notification__item" data-cart-key="' + escapeHtml(item.key) + '">',
          '<a class="wng-cart-notification__image-link" href="' + escapeHtml(itemUrl) + '">',
            imageUrl ? '<img class="wng-cart-notification__image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(itemTitle) + '" width="96" height="120" loading="lazy">' : '<span class="wng-cart-notification__image-placeholder wng-product-card__no-image"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false"><rect x="4" y="8" width="40" height="32" rx="3" stroke="#6B7D8F" stroke-width="2"/><circle cx="18" cy="20" r="4" stroke="#6B7D8F" stroke-width="2"/><path d="M4 32L14 22L22 30L30 22L44 36" stroke="#6B7D8F" stroke-width="2" stroke-linecap="round"/></svg></span>',
          '</a>',
          '<div class="wng-cart-notification__details">',
            '<a class="wng-cart-notification__item-title" href="' + escapeHtml(itemUrl) + '">' + escapeHtml(itemTitle) + '</a>',
            variantText ? '<p class="wng-cart-notification__variant">' + escapeHtml(variantText) + '</p>' : '',
            '<p class="wng-cart-notification__price">' + formatMoney(item.final_line_price || item.line_price) + '</p>',
            '<div class="wng-cart-notification__quantity" aria-label="Quantity controls">',
              '<button type="button" data-wng-cart-key="' + escapeHtml(item.key) + '" data-quantity="' + previousQuantity + '" aria-label="Decrease quantity"' + minusDisabled + '>-</button>',
              '<span>' + item.quantity + '</span>',
              '<button type="button" data-wng-cart-key="' + escapeHtml(item.key) + '" data-quantity="' + nextQuantity + '" aria-label="Increase quantity">+</button>',
            '</div>',
          '</div>',
          '<button type="button" class="wng-cart-notification__remove" data-wng-cart-key="' + escapeHtml(item.key) + '" data-quantity="0" aria-label="Remove ' + escapeHtml(itemTitle) + '">x</button>',
        '</article>'
      ].join('');
    }).join('');
  }

  function renderCartSummary(cart) {
    var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var totalPrice = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var progress = freeShippingThreshold > 0 ? Math.min(totalPrice / freeShippingThreshold, 1) * 100 : 100;
    var remaining = Math.max(freeShippingThreshold - totalPrice, 0);

    if (cartDrawerCount) cartDrawerCount.textContent = '(' + itemCount + ')';
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(totalPrice);
    if (cartDrawerProgress) cartDrawerProgress.style.width = progress + '%';
    if (cartDrawerShippingText) {
      cartDrawerShippingText.textContent = remaining > 0
        ? 'Spend ' + formatMoney(remaining) + ' more for free shipping'
        : 'You qualify for free shipping';
    }
  }

  function setCartDrawerError(message) {
    if (!cartDrawerItems) return;

    var errorEl = document.getElementById('wng-cart-notification-error');
    if (!message) {
      if (errorEl) errorEl.remove();
      return;
    }

    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.id = 'wng-cart-notification-error';
      errorEl.className = 'wng-cart-notification__error';
      errorEl.setAttribute('role', 'alert');
      cartDrawerItems.insertAdjacentElement('afterbegin', errorEl);
    }

    errorEl.textContent = message;
  }

  function renderRecommendations(addedItem) {
    if (!cartDrawerRecommendations || !cartDrawerRecommendationGrid) return;

    var productId = addedItem && addedItem.product_id;
    if (!productId) {
      cartDrawerRecommendations.hidden = true;
      cartDrawerRecommendationGrid.innerHTML = '';
      return;
    }

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=4')
      .then(function(response) {
        if (!response.ok) throw new Error('No recommendations.');
        return response.json();
      })
      .then(function(data) {
        var products = data && data.products ? data.products.slice(0, 4) : [];
        if (!products.length) {
          cartDrawerRecommendations.hidden = true;
          cartDrawerRecommendationGrid.innerHTML = '';
          return;
        }

        cartDrawerRecommendationGrid.innerHTML = products.map(function(product) {
          var imageUrl = getImageUrl(product.featured_image);
          return [
            '<a class="wng-cart-notification__recommendation" href="' + escapeHtml(product.url) + '">',
              imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + '" width="150" height="150" loading="lazy">' : '<span class="wng-cart-notification__recommendation-placeholder wng-product-card__no-image"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false"><rect x="4" y="8" width="40" height="32" rx="3" stroke="#6B7D8F" stroke-width="2"/><circle cx="18" cy="20" r="4" stroke="#6B7D8F" stroke-width="2"/><path d="M4 32L14 22L22 30L30 22L44 36" stroke="#6B7D8F" stroke-width="2" stroke-linecap="round"/></svg></span>',
              product.vendor ? '<span>' + escapeHtml(product.vendor) + '</span>' : '',
              '<p>' + escapeHtml(product.title) + '</p>',
              '<strong>' + formatMoney(product.price) + '</strong>',
            '</a>'
          ].join('');
        }).join('');

        cartDrawerRecommendations.hidden = false;
      })
      .catch(function() {
        cartDrawerRecommendations.hidden = true;
        cartDrawerRecommendationGrid.innerHTML = '';
      });
  }

  function renderCartDrawer(cart, addedItem) {
    renderCartItems(cart);
    renderCartSummary(cart);
    var recommendationSource = addedItem || (cart.items && cart.items.length ? cart.items[0] : null);
    renderRecommendations(recommendationSource);
    setCartDrawerError('');
    window.wngUpdateCartCount(cart);
  }

  function openCartDrawer(cart, addedItem) {
    if (!cartDrawer) return;

    renderCartDrawer(cart, addedItem);
    cartDrawer.inert = false;
    cartDrawer.removeAttribute('inert');
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wng-cart-drawer-open');

    var closeButton = cartDrawer.querySelector('[data-wng-cart-notification-close]:not(.wng-cart-notification__overlay)');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.inert = true;
    cartDrawer.setAttribute('inert', '');
    cartDrawer.removeAttribute('aria-busy');
    document.documentElement.classList.remove('wng-cart-drawer-open');
  }

  function addCartItem(variantId, quantity) {
    variantId = parseInt(variantId, 10);
    quantity = parseInt(quantity, 10) || 1;

    if (!variantId) return Promise.reject(new Error('Please select a valid product option.'));

    return fetchJson('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function(addedItem) {
        return fetchCart().then(function(cart) {
          return { addedItem: addedItem, cart: cart };
        });
      });
  }

  function changeCartItem(key, quantity) {
    if (!key) return Promise.reject(new Error('Unable to identify cart item.'));
    quantity = parseInt(quantity, 10);
    if (Number.isNaN(quantity)) return Promise.reject(new Error('Unable to update quantity.'));

    return fetchJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  window.wngUpdateCartCount = function(cart) {
    function update(cartData) {
      var cartLink = document.querySelector('.wng-nav__cart');
      var countEl = document.querySelector('.wng-nav__cart-count');
      var itemCount = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : 0;

      if (cartLink) {
        cartLink.setAttribute('aria-label', 'Cart (' + getCartItemCountText(itemCount) + ')');
      }

      if (itemCount > 0) {
        if (!countEl && cartLink) {
          countEl = document.createElement('span');
          countEl.className = 'wng-nav__cart-count';
          cartLink.appendChild(countEl);
        }
        if (countEl) countEl.textContent = itemCount;
      } else if (countEl) {
        countEl.remove();
      }

      return cartData;
    }

    if (cart) return Promise.resolve(update(cart));
    return fetchCart().then(update);
  };

  if (cartDrawer) {
    window.wngAddCartItem = function(variantId, quantity) {
      return addCartItem(variantId, quantity).then(function(result) {
        openCartDrawer(result.cart, result.addedItem);
        return result;
      });
    };

    window.wngOpenCartNotification = function(addedItem, cart) {
      if (cart) {
        openCartDrawer(cart, addedItem);
        return;
      }

      fetchCart().then(function(cartData) {
        openCartDrawer(cartData, addedItem);
      });
    };

    document.querySelectorAll('.wng-nav__cart').forEach(function(cartLink) {
      cartLink.addEventListener('click', function(event) {
        if (window.location.pathname.replace(/\/$/, '') === '/cart') return;

        event.preventDefault();
        setCartDrawerBusy(true);
        setCartDrawerError('');

        fetchCart()
          .then(function(cart) {
            openCartDrawer(cart);
          })
          .catch(function() {
            window.location.href = cartLink.getAttribute('href') || '/cart';
          })
          .finally(function() {
            setCartDrawerBusy(false);
          });
      });
    });

    cartDrawer.querySelectorAll('[data-wng-cart-notification-close]').forEach(function(control) {
      control.addEventListener('click', closeCartDrawer);
    });

    cartDrawer.addEventListener('click', function(event) {
      var quantityButton = event.target.closest('[data-wng-cart-key]');
      if (!quantityButton) return;

      event.preventDefault();
      setCartDrawerBusy(true);
      setCartDrawerError('');

      changeCartItem(quantityButton.getAttribute('data-wng-cart-key'), quantityButton.getAttribute('data-quantity'))
        .then(function(cart) {
          renderCartDrawer(cart);
        })
        .catch(function(error) {
          setCartDrawerError(error.message);
        })
        .finally(function() {
          setCartDrawerBusy(false);
        });
    });
  }

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeCartDrawer();
    }
  });

  /* ---- Mobile nav toggle ---- */
  var hamburger = document.querySelector('.wng-nav__hamburger');
  var mobileMenu = document.querySelector('.wng-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      if (isOpen) closeSearchPanel();
    });

    mobileMenu.querySelectorAll('.wng-mobile-menu__details').forEach(function(details) {
      details.addEventListener('toggle', function() {
        if (!details.open) {
          details.querySelectorAll('.wng-mobile-menu__group[open]').forEach(function(group) {
            group.open = false;
          });
          return;
        }

        mobileMenu.querySelectorAll('.wng-mobile-menu__details[open]').forEach(function(otherDetails) {
          if (otherDetails !== details) otherDetails.open = false;
        });
      });
    });
  }

  /* ---- Search toggle ---- */
  var searchToggle = document.getElementById('wng-search-toggle');
  var searchPanel = document.getElementById('wng-nav-search');
  var searchClose = document.getElementById('wng-search-close');
  var searchInput = document.getElementById('wng-search-input');
  var searchForm = document.getElementById('wng-search-form');
  var searchResults = document.getElementById('wng-predictive-search-results');
  var popularSearches = document.getElementById('wng-popular-searches');
  var searchAbortController = null;
  var searchDebounceTimer = null;

  function setSearchOpen(open) {
    if (!searchPanel) return;
    searchPanel.classList.toggle('is-open', open);
    searchPanel.setAttribute('aria-hidden', String(!open));
    if (searchToggle) searchToggle.setAttribute('aria-expanded', String(open));
    if (searchInput) searchInput.setAttribute('aria-expanded', String(open && searchResults && !searchResults.hidden));
  }

  function resetPredictiveSearch() {
    if (searchAbortController) searchAbortController.abort();
    searchAbortController = null;
    window.clearTimeout(searchDebounceTimer);
    if (searchResults) {
      searchResults.hidden = true;
      searchResults.classList.remove('is-loading');
      searchResults.innerHTML = '';
    }
    if (popularSearches) popularSearches.hidden = false;
    if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
  }

  function closeSearchPanel() {
    setSearchOpen(false);
    resetPredictiveSearch();
  }

  function getSearchSuggestUrl(query) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'search/suggest?q=' + encodeURIComponent(query) + '&section_id=wng-predictive-search&resources[type]=product,query&resources[limit]=8&resources[limit_scope]=each';
  }

  function getSearchCountUrl(query) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'search?q=' + encodeURIComponent(query) + '&type=product&section_id=main-search';
  }

  function updatePredictiveResultCount(query) {
    if (!searchResults) return;

    fetch(getSearchCountUrl(query))
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load result count.');
        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var countNode = doc.querySelector('.wng-search-page__meta strong');
        var count = countNode ? parseInt(countNode.textContent.replace(/[^0-9]/g, ''), 10) : 0;
        var viewAll = searchResults.querySelector('.wng-predictive-search__view-all');

        if (!viewAll || Number.isNaN(count) || count < 1) return;
        viewAll.innerHTML = 'See ' + count.toLocaleString('en-US') + ' filtered result' + (count === 1 ? '' : 's') + ' for "' + query + '" <span aria-hidden="true">&rsaquo;</span>';
      })
      .catch(function() {});
  }

  function buildPredictiveFilterUrl(filterType, filterValue, query) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var searchUrl = root + 'search';
    var params = new URLSearchParams();
    var cleanQuery = (query || '').trim();
    var normalizedQuery = cleanQuery.toLowerCase().replace(/[^a-z0-9]/g, '');
    var normalizedValue = filterValue.toLowerCase().replace(/[^a-z0-9]/g, '');

    params.set('type', 'product');

    if (filterType === 'brand') {
      params.set('q', filterValue);
    } else {
      params.set('q', (cleanQuery ? cleanQuery + ' ' : '') + (filterType === 'size' ? 'size ' : '') + filterValue);
    }

    return searchUrl + '?' + params.toString();
  }

  function renderPredictiveSearch(query) {
    if (!searchResults) return;
    if (searchAbortController) searchAbortController.abort();
    searchAbortController = window.AbortController ? new AbortController() : null;

    searchResults.hidden = false;
    searchResults.classList.add('is-loading');
    if (popularSearches) popularSearches.hidden = true;
    if (searchInput) searchInput.setAttribute('aria-expanded', 'true');

    fetch(getSearchSuggestUrl(query), {
      signal: searchAbortController ? searchAbortController.signal : undefined
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load search suggestions.');
        return response.text();
      })
      .then(function(html) {
        searchResults.innerHTML = html.trim();
        updatePredictiveResultCount(query);
      })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        searchResults.innerHTML = '<p class="wng-predictive-search__empty">Unable to load suggestions. Press Enter to search.</p>';
      })
      .finally(function() {
        searchResults.classList.remove('is-loading');
      });
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = !searchPanel.classList.contains('is-open');
      if (open && hamburger && mobileMenu) {
        mobileMenu.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      }
      setSearchOpen(open);
      if (open && searchInput) setTimeout(function() { searchInput.focus(); }, 50);
      if (!open) resetPredictiveSearch();
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', closeSearchPanel);
  }
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function() {
      var query = searchInput.value.trim();
      window.clearTimeout(searchDebounceTimer);

      if (query.length < 2) {
        resetPredictiveSearch();
        return;
      }

      searchDebounceTimer = window.setTimeout(function() {
        renderPredictiveSearch(query);
      }, 220);
    });

    searchResults.addEventListener('click', function(event) {
      var filterLink = event.target.closest('[data-predictive-filter]');
      if (!filterLink) return;

      event.preventDefault();
      window.location.href = buildPredictiveFilterUrl(
        filterLink.getAttribute('data-predictive-filter'),
        filterLink.getAttribute('data-filter-value'),
        searchInput.value
      );
    });
  }
  if (searchForm && searchInput) {
    searchForm.addEventListener('submit', function(event) {
      if (!searchInput.value.trim()) {
        event.preventDefault();
        searchInput.focus();
      }
    });
  }
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && searchPanel && searchPanel.classList.contains('is-open')) {
      closeSearchPanel();
    }
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.wng-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.wng-faq__item');
      var isOpen = item.classList.contains('wng-faq__item--open');
      document.querySelectorAll('.wng-faq__item').forEach(function (i) {
        i.classList.remove('wng-faq__item--open');
        i.querySelector('.wng-faq__question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('wng-faq__item--open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---- Quick Add to cart ---- */
  window.wngQuickAdd = function(event, variantId) {
    event.preventDefault();
    var btn = event.currentTarget;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    var addRequest = window.wngAddCartItem ? window.wngAddCartItem(variantId, 1) : addCartItem(variantId, 1).then(function(result) {
      window.wngUpdateCartCount(result.cart);
      return result;
    });

    addRequest
      .then(function() {
        btn.textContent = 'Added!';
      })
      .catch(function() {
        btn.textContent = originalText;
      })
      .finally(function() {
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);
      });
  };

  /* ---- Sticky header shadow on scroll ---- */
  var header = document.getElementById('wng-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('wng-header--scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- Smooth scroll for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(event) {
      var target = document.getElementById(this.getAttribute('href').slice(1));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
